"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    BaseJwtService: ()=>BaseJwtService
});
const external_jwt_util_js_namespaceObject = require("./jwt.util.js");
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
class BaseJwtService {
    checkNotSupportedMode(list, funcName) {
        if (list.includes(this.mode)) throw new Error(`BaseJwtService function ${funcName} not support ${this.mode} mode`);
    }
    setTicketQuery(ticket) {
        this.ticketQuery = ticket;
    }
    getLoginLink(next) {
        this.checkNotSupportedMode([
            'downgrade',
            'serviceAccount'
        ], 'getLoginLink');
        return `${this.baseUrl}${this.pathMap.login}?next=${encodeURIComponent(next || window.location.href)}`;
    }
    redirectToLogin(next) {
        this.checkNotSupportedMode([
            'downgrade',
            'serviceAccount'
        ], 'redirectToLogin');
        window.location.href = this.getLoginLink(next);
        return new Promise(()=>void 0);
    }
    redirectToLogout() {
        let next = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.getLoginLink();
        this.checkNotSupportedMode([
            'downgrade',
            'serviceAccount'
        ], 'redirectToLogout');
        window.location.href = `${this.baseUrl}${this.pathMap.logout}?next=${encodeURIComponent(next)}`;
    }
    async fetchLogout() {
        this.checkNotSupportedMode([
            'downgrade',
            'serviceAccount'
        ], 'redirectToLogout');
        const url = `${this.baseUrl}${this.pathMap.logout}`;
        return await fetch(url, {
            mode: 'cors',
            credentials: 'include'
        });
    }
    async pureFetchJwt() {
        this.checkNotSupportedMode([
            'downgrade'
        ], 'pureFetchJwt');
        const url = `${this.baseUrl}${this.pathMap.jwt}${this.ticketQuery ? `?jwt_ticket=${this.ticketQuery}` : ''}`;
        this.ticketQuery = void 0;
        let controller;
        let timeout;
        if ('number' == typeof this.fetchTimeout) {
            controller = new AbortController();
            timeout = setTimeout(()=>{
                null == controller || controller.abort();
            }, this.fetchTimeout);
        }
        if ('serviceAccount' === this.mode) return await fetch(url, {
            mode: 'cors',
            headers: {
                Authorization: `Bearer ${this.secret}`
            },
            signal: null == controller ? void 0 : controller.signal
        }).finally(()=>{
            if (void 0 !== timeout) clearTimeout(timeout);
        });
        return await fetch(url, {
            mode: 'cors',
            credentials: 'include',
            signal: null == controller ? void 0 : controller.signal
        }).finally(()=>{
            if (void 0 !== timeout) clearTimeout(timeout);
        });
    }
    async fetchJwt() {
        if ('downgrade' === this.mode) return this.downgradedJwt;
        const res = await this.pureFetchJwt();
        const token = res.headers.get('X-Jwt-Token');
        if (token) {
            this.saveJwt(token);
            return token;
        }
        if (401 === res.status && 'normal' === this.mode) await this.redirectToLogin();
        throw new Error(`BaseJwtService fetch jwt failed. uniqueKey: ${this.uniqueKey}; statusText: ${res.statusText}`);
    }
    checkValid(jwt) {
        if ('downgrade' === this.mode) return true;
        const parsed = jwt && (0, external_jwt_util_js_namespaceObject.parseJwt)(jwt);
        if (!parsed) return false;
        {
            const isExpired = parsed.exp < (Date.now() + 300000) / 1000;
            const isDowngrade = !this.skipDowngradeCheck && Boolean(parsed.downgrade);
            const isRegionMatched = !parsed.region || !this.jwtRegion || this.jwtRegion === parsed.region;
            return !isExpired && !isDowngrade && isRegionMatched;
        }
    }
    throttleFetchJwtAndCache() {
        if (!this.throttleResult) this.throttleResult = this.fetchJwt().finally(()=>{
            this.throttleResult = void 0;
        });
        this.setCache(this.throttleResult);
        return this.throttleResult;
    }
    getCachedJwt() {
        const cacheResult = this.getCache();
        if (!cacheResult) return;
        return cacheResult.then((jwt)=>{
            const isValid = this.checkValid(jwt);
            return isValid ? jwt : void 0;
        });
    }
    getJwt() {
        if ('downgrade' === this.mode) return Promise.resolve(this.downgradedJwt);
        const result = this.getCachedJwt();
        if (!result) return this.throttleFetchJwtAndCache();
        return result.then((jwt)=>jwt ? jwt : this.throttleFetchJwtAndCache()).catch((err)=>{
            this.setCache(void 0);
            throw err;
        });
    }
    async _getLoginInfo() {
        if ('downgrade' === this.mode) return {
            status: 200,
            jwt: this.downgradedJwt
        };
        const result = await this.getCachedJwt();
        if (result) return {
            status: 200,
            jwt: result
        };
        const res = await this.pureFetchJwt();
        const token = res.headers.get('X-Jwt-Token');
        if (token) {
            this.setCache(Promise.resolve(token));
            this.saveJwt(token);
            return {
                status: 200,
                jwt: token
            };
        }
        {
            let body;
            try {
                body = await res.text();
            } catch (error) {}
            return {
                status: res.status,
                statusText: res.statusText,
                body
            };
        }
    }
    logout(next) {
        var _this_resetJwt, _this;
        this.checkNotSupportedMode([
            'downgrade',
            'serviceAccount'
        ], 'logout');
        null == (_this_resetJwt = (_this = this).resetJwt) || _this_resetJwt.call(_this);
        this.setCache(void 0);
        this.redirectToLogout(next);
    }
    clearCache() {
        this.setCache(void 0);
    }
    constructor(props){
        _define_property(this, "uniqueKey", void 0);
        _define_property(this, "_promiseCache", void 0);
        _define_property(this, "throttleResult", void 0);
        _define_property(this, "getCache", void 0);
        _define_property(this, "setCache", void 0);
        _define_property(this, "baseUrl", void 0);
        _define_property(this, "pathMap", void 0);
        _define_property(this, "jwtRegion", void 0);
        _define_property(this, "saveJwt", void 0);
        _define_property(this, "resetJwt", void 0);
        _define_property(this, "mode", 'normal');
        _define_property(this, "secret", void 0);
        _define_property(this, "downgradedJwt", void 0);
        _define_property(this, "fetchTimeout", void 0);
        _define_property(this, "ticketQuery", void 0);
        _define_property(this, "skipDowngradeCheck", void 0);
        this.uniqueKey = props.uniqueKey;
        this.baseUrl = props.baseUrl;
        this.jwtRegion = props.jwtRegion;
        this.resetJwt = props.resetJwt;
        this.fetchTimeout = props.fetchTimeout;
        this.pathMap = props.pathMap || {
            login: '/login',
            logout: '/logout',
            jwt: '/jwt'
        };
        this.ticketQuery = props.ticketQuery;
        this.skipDowngradeCheck = props.skipDowngradeCheck;
        this.mode = props.mode || 'normal';
        switch(props.mode){
            case 'serviceAccount':
                if (props.secret) this.secret = props.secret;
                else throw new Error('BaseJwtService initialize failed, serviceAccount mode must have a secret parameter');
                break;
            case 'downgrade':
                if (props.downgradedJwt) this.downgradedJwt = props.downgradedJwt;
                else throw new Error('BaseJwtService initialize failed, downgrade mode must have a downgradedJwt parameter');
                break;
            default:
                break;
        }
        this.getCache = ()=>{
            if ('function' == typeof props.getPromiseCache && 'function' == typeof props.setPromiseCache) return props.getPromiseCache();
            return this._promiseCache;
        };
        this.setCache = (content)=>{
            if ('function' == typeof props.getPromiseCache && 'function' == typeof props.setPromiseCache) props.setPromiseCache(content);
            this._promiseCache = content;
        };
        this.saveJwt = (jwt)=>{
            var _props_saveJwt;
            null == (_props_saveJwt = props.saveJwt) || _props_saveJwt.call(props, jwt);
        };
    }
}
exports.BaseJwtService = __webpack_exports__.BaseJwtService;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "BaseJwtService"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
